export default "__VITE_ASSET__017463dc__"